// Ported from ai-bot-ui (src/utils/chatOptions.js) to keep both frontends
// rendering the same in-chat option contract.

/** Raw options payload as emitted by the backend on `on_stream_end`. */
export interface RawStreamOptions {
  button?: string[];
  select?: { items?: string[] };
}

export type NormalizedOptions =
  | { type: "button"; items: string[] }
  | { type: "select"; items: string[] }
  | null;

/** Normalize backend options payload into a renderable shape, or null. */
export const normalizeStreamOptions = (
  options?: RawStreamOptions | null,
): NormalizedOptions => {
  if (!options) return null;

  const buttons = Array.isArray(options.button)
    ? options.button.filter(Boolean)
    : [];
  if (buttons.length > 0) {
    return { type: "button", items: buttons };
  }

  const selectItems = Array.isArray(options.select?.items)
    ? options.select!.items!.filter(Boolean)
    : [];
  if (selectItems.length > 0) {
    return { type: "select", items: selectItems };
  }

  return null;
};

/** Display-friendly label; send the raw value to the API unchanged. */
export const formatOptionLabel = (value: string): string => {
  if (!value || typeof value !== "string") return value;

  // Values that already contain lowercase (e.g. "Monday, June 15") render as-is.
  if (/[a-z]/.test(value)) return value;

  // Uppercase transport tokens (e.g. "DROPOFF") are title-cased for display only.
  return value
    .split("_")
    .map((part) => part.charAt(0) + part.slice(1).toLowerCase())
    .join(" ");
};
